import React, { useState, useEffect } from "react";
import { FaChevronLeft, FaChevronRight } from "react-icons/fa";

// Yerel görselleri import ediyoruz
import doha1 from "../assets/doha1.jpeg";
// import medine from "../assets/medine.jpeg";
import mekke1 from "../assets/mekke1.jpeg";
import kahire1 from "../assets/kahire1.jpeg";
import saraybosna1 from "../assets/saraybosna1.jpeg";

// Tüm görselleri bir dizide topluyoruz
const sliderImages = [doha1, mekke1,kahire1 , saraybosna1];

const SliderBanner = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev + 1) % sliderImages.length);
  };

  const prevSlide = () => {
    setCurrentIndex((prev) =>
      prev === 0 ? sliderImages.length - 1 : prev - 1
    );
  };

  const goToSlide = (index) => {
    setCurrentIndex(index);
  };

  return (
    <div
    style={{
      position: "relative",
      width: "100%",
      maxWidth: "1920px",
      height: "auto",
      aspectRatio: "1920 / 800", // oranı korur
      margin: "0 auto",
      overflow: "hidden",
      backgroundColor: "#000",
    }}
  >
    <img
      src={sliderImages[currentIndex]}
      alt={`Slide ${currentIndex}`}
      style={{
        width: "100%",
        height: "100%",
        objectFit: "contain", // GÖRSEL TAMAMEN GÖRÜNÜR
        transition: "opacity 1s ease-in-out",
      }}
    />
  

      {/* Sol buton */}
      <button
        onClick={prevSlide}
        style={{
          position: "absolute",
          top: "50%",
          left: "20px",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(0,0,0,0.4)",
          color: "#fff",
          border: "none",
          padding: "10px",
          borderRadius: "50%",
          cursor: "pointer",
          zIndex: 2,
        }}
      >
        <FaChevronLeft />
      </button>

      {/* Sağ buton */}
      <button
        onClick={nextSlide}
        style={{
          position: "absolute",
          top: "50%",
          right: "20px",
          transform: "translateY(-50%)",
          backgroundColor: "rgba(0,0,0,0.4)",
          color: "#fff",
          border: "none",
          padding: "10px",
          borderRadius: "50%",
          cursor: "pointer",
          zIndex: 2,
        }}
      >
        <FaChevronRight />
      </button>

      {/* Dot göstergeleri */}
      <div
        style={{
          position: "absolute",
          bottom: "20px",
          width: "100%",
          display: "flex",
          justifyContent: "center",
          gap: "12px",
          zIndex: 2,
        }}
      >
        {sliderImages.map((_, index) => (
          <div
            key={index}
            onClick={() => goToSlide(index)}
            style={{
              width: currentIndex === index ? "16px" : "14px",
              height: currentIndex === index ? "16px" : "14px",
              borderRadius: "50%",
              backgroundColor:
                currentIndex === index ? "#ffffff" : "rgba(255,255,255,0.6)",
              cursor: "pointer",
              boxShadow:
                currentIndex === index
                  ? "0 0 6px rgba(255,255,255,0.8)"
                  : "none",
              transition: "all 0.3s ease",
            }}
          />
        ))}
      </div>
    </div>
  );
};

export default SliderBanner;
